import React, { useEffect, useState } from 'react'
import Header from './layout/Header'
import Footer from './layout/Footer'
import * as websiteService from './services/website.services'
import { autoHyperlinkHtml } from '../../utils/commonfunction'
import './Home.css'

function PrivacyPolicyWebsite() {
    const [cmsData, setCmsData] = useState(null);

    useEffect(() => {
        const fetchCms = async () => {
            try {
                const response = await websiteService.CMSPage('privacy_web');
                if (response.success) {
                    setCmsData(response.data);
                }
            } catch (error) {
                console.error("Failed to fetch Privacy Policy Website content", error);
            }
        };
        fetchCms();
    }, []);

    return (
        <React.Fragment>
            <Header />
            <main className="cms-page-content">
                <section className="padding-top-100 padding-bottom-100">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                {cmsData ? (
                                    <div className="cms-copy">
                                        <h1 className="cms-title mb-4">{cmsData.title || 'Privacy Policy'}</h1>
                                        <div 
                                            className="cms-description" 
                                            dangerouslySetInnerHTML={{ __html: autoHyperlinkHtml(cmsData.description) }} 
                                        />
                                    </div>
                                ) : (
                                    <div className="text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </React.Fragment>
    )
}

export default PrivacyPolicyWebsite
